module.exports = __webpack_public_path__ + "img/custom-on.7bbfaeec.svg";